import React, { useState } from 'react'
import MyButton from '../../../UI/form/MyButton'
import MyModal from '../../../UI/modal/MyModal'
import WriteOffActForm from './WriteOffActForm'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

const WriteOffActFormButton = ({ writeOffAct }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                writeOffAct ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            classNameAdd='supplyOrderModal'
            open={open}
            setOpen={setOpen}
            header={writeOffAct ? 'Редагувати акт на списання' : 'Додати акт на списання'}
            disableClickOutside={true}
            content={
                <WriteOffActForm
                    writeOffActBd={writeOffAct}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default WriteOffActFormButton